<template>
  <div style="flex: 1; padding: 20px">
    <el-row>
      <el-button v-if="checkPermission('createUser')" style="float: right; margin-right: 30px" @click="create()">{{
          $t("admin.create")
      }}</el-button>
    </el-row>
    <br />
    <el-table v-loading="loading" :data="users">
      <el-table-column :label="$t('admin.name') + ' ' + $t('admin.surname')">
        <template slot-scope="scope">
          <span>{{ scope.row.name }} {{ scope.row.surname }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="email" :label="$t('admin.email')"></el-table-column>
      <el-table-column prop="role" :label="$t('admin.userType')">
        <template slot-scope="scope">
          <span>{{ $t(`userrole.${scope.row.role}`) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" :label="$t('admin.createdAt')">
        <template slot-scope="scope">
          <span>{{ dateDate(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" :label="$t('admin.phone')"></el-table-column>
      <el-table-column width="300px" :label="$t('admin.actions')" id="action">
        <template slot-scope="scope">
          <el-button v-if="checkPermission('updateUser')" size="small" @click="Edit(scope.row._id)">{{ $t("admin.edit")
          }}</el-button>
          <el-popover style="margin: 0px 10px" v-if="checkPermission('deleteUser') && changePasswordAuthority"
            placement="left" trigger="click" width="400" v-model="scope.row.resetPasswordVisible">
            <p>
              {{ $t("admin.areYouResetPassword") }}
              <br />
              {{ $t("admin.copyPassword") }}: {{ generatedPassword }}
              <el-tooltip :content="generatedPassword" placement="top">
                <em @click="copyIdToClipboard()" style="margin-left: 5px; margin-right: 5px" class="far fa-clipboard"
                  size="small"></em>
              </el-tooltip>
            </p>
            <div style="text-align: right; margin: 0">
              <el-button size="small" @click="scope.row.resetPasswordVisible = false">{{
                  $t("common.cancel")
              }}</el-button>
              <el-button v-if="checkPermission('deleteUser')" size="small" @click="resetPassword(scope)">{{
                  $t("NavUser.resetPassword")
              }}</el-button>
            </div>
            <el-button size="small" slot="reference" @click="generatePassword(scope)">{{ $t("NavUser.resetPassword") }}
            </el-button>
          </el-popover>
          <el-button v-if="checkPermission('deleteUser')" size="small" type="danger" @click="Delete(scope.row._id)">{{
              $t("admin.delete")
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog width="30%" title="Edit User" ref="ruleForm" :visible.sync="showForm">
      <el-form ref="form" :model="form" :rules="rules" v-loading="formLoading" label-width="35%">
        <el-form-item :label="$t('admin.role')" prop="role">
          <el-select v-model="form.role" placeholder="Select Role">
            <el-option v-for="item in roles" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('admin.name')" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('admin.surname')" prop="surname">
          <el-input v-model="form.surname"></el-input>
        </el-form-item>
        <el-form-item :label="$t('admin.phone')" prop="phone">
          <VuePhoneNumberInput v-model="form.phone" default-country-code="TR" color="dodgerblue"
            :translations="translations" clearable valid-color="#F97B14" />
        </el-form-item>
        <hr />
        <p>{{ $t("admin.createtext") }}</p>
        <el-form-item :label="$t('admin.email')" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="UpdateUser()">{{
              $t("admin.update")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- Create form start -->
    <el-dialog width="30%" :title="$t('admin.createuser')" ref="ruleForm" :visible.sync="showCreateForm">
      <el-form ref="createForm" :model="createForm" :rules="createRules" v-loading="createFormLoading"
        label-width="35%">
        <el-form-item :label="$t('admin.role')" prop="role">
          <el-select v-model="createForm.role" placeholder="Select Role">
            <el-option v-for="item in roles" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('admin.name')" prop="name">
          <el-input v-model="createForm.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('admin.surname')" prop="surname">
          <el-input v-model="createForm.surname"></el-input>
        </el-form-item>
        <el-form-item :label="$t('admin.phone')" prop="phone">
          <VuePhoneNumberInput v-model="createForm.phone" default-country-code="TR" color="dodgerblue"
            :translations="translations" clearable valid-color="#F97B14" />
        </el-form-item>
        <hr />
        <p>{{ $t("admin.createtext") }}</p>
        <el-form-item :label="$t('admin.email')" prop="email">
          <el-input v-model="createForm.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('admin.password')" prop="password">
          <el-input v-model="createForm.password" show-password></el-input>
        </el-form-item>

        <el-form-item style="margin: 0px; padding: 0px; text-align:left">
            <p v-if="customer && customer.preferences && customer.preferences.passwordPolicy">
              <div class="validateerrors">
          <li v-if="customer.preferences.passwordPolicy.minCharacter">
          <span v-if="createForm.password.length<customer.preferences.passwordPolicy.minCharacter" style="color:red">{{"Min. Password Length "+customer.preferences.passwordPolicy.minCharacter}}</span>
          <span v-else style="color:green">{{"Min. Password Length "+customer.preferences.passwordPolicy.minCharacter}}</span>
         </li>
          <li v-if="customer.preferences.passwordPolicy.requiresLowerCaseLetters">
          <span v-if="!new RegExp(`[${this.lowerReg}]`).test(createForm.password)"  style="color:red">{{"Min. One LowerCase Character "}}</span>
           <span v-else style="color:green">{{"Min. One LowerCase Character "}}</span>
          </li>
           <li v-if="customer.preferences.passwordPolicy.requiresUpperCaseLetters">
          <span v-if="!new RegExp(`[${this.upperReg}]`).test(createForm.password)" style="color:red">{{"Min. One UpperCase Character "}}</span>
            <span v-else style="color:green">{{"Min. One UpperCase Character "}}</span>
           </li>
           <li v-if="customer.preferences.passwordPolicy.requiresSpecialCharacters">
           <span v-if="!new RegExp(`[${this.specialReg}]`).test(createForm.password)" style="color:red">{{"Min. One Special Character "}}</span>
            <span v-else style="color:green">{{"Min. One Special Character "}}</span>
           </li>
            <li v-if="customer.preferences.passwordPolicy.requiresNumbers">
           <span v-if="!new RegExp(`[${this.numberReg}]`).test(createForm.password)" style="color:red">{{"Min. One Numeric Character "}}</span>
            <span v-else style="color:green">{{"Min. One Numeric Character "}}</span>
            </li>
 </div>
            </p>
          </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="CreateUserfunc()">{{
              $t("admin.create")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- Create form Finish -->
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";
import dayjs from "dayjs-ext";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import preferences from "../util/preferences";
import generatePass from "generate-password";
import passwordCheck from "../util/passwordCheck";
import axios from "axios";
export default {
  name: "Admin",
  components: { VuePhoneNumberInput },
  data() {
    var validatePass = (rule, value, callback) => {
      if (
        !passwordCheck.checkPassword(value, this.customer.preferences.passwordPolicy).result
      ) {
        callback(new Error(`Weak Password`));
        return;
      }
      else if (value === "") {
        callback(new Error("Please input the password again"));
      } 
      else {
        callback();
      }
    };
    return {
      upperReg:passwordCheck.upper,
      lowerReg:passwordCheck.lower,
      specialReg:passwordCheck.special,
      numberReg:passwordCheck.number,
      phoneNumber: null,
      generatedPassword: "",
      translations: {
        countrySelectorLabel: this.$t("admin.codePays"),
        countrySelectorError: this.$t("admin.countrySelectorError"),
        phoneNumberLabel: this.$t("admin.phoneNumberLabel"),
        example: "",
      },
      results: {},
      roles: [
        { label: this.$t("userrole.user"), value: "user" },
        { label: this.$t("userrole.admin"), value: "admin" },
      ],
      formLoading: false,
      createFormLoading: false,
      showForm: false,
      showCreateForm: false,
      editId: "",
      form: {
        role: "user",
        name: "",
        surname: "",
        phone: "",
        email: "",
        password: "",
      },
      createForm: {
        role: "user",
        name: "",
        surname: "",
        phone: "",
        email: "",
        password: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("admin.requirename"),
            trigger: "blur",
          },
        ],
        surname: [
          {
            required: true,
            message: this.$t("admin.requiresurname"),
            trigger: "blur",
          },
        ],
        role: [
          {
            required: true,
            message: this.$t("admin.requirerole"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("admin.requireemail"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("admin.requirepassword"),
            trigger: "blur",
          },
        ],
      },
      createRules: {
        name: [
          {
            required: true,
            message: this.$t("admin.requirename"),
            trigger: "blur",
          },
        ],
        surname: [
          {
            required: true,
            message: this.$t("admin.requiresurname"),
            trigger: "blur",
          },
        ],
        role: [
          {
            required: true,
            message: this.$t("admin.requirerole"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("admin.requireemail"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("admin.requirepassword"),
            trigger: "blur",
          },
          {
            required: true,
            validator: validatePass,
            message: this.$t("admin.weakpassword"),
            trigger: "change"
          }
        ],

      },
    };
  },
  created() {
    this.getUsers();
  },
  computed: {
    ...mapState("admin", ["users", "loading"]),
    ...mapState("account", ["customer"]),
    resultsTable() {
      return Object.keys(this.results);
    },
    changePasswordAuthority() {
      return JSON.parse(localStorage.getItem("user")).role == "admin";
    },
  },

  methods: {
    ...mapActions("admin", [
      "createUser",
      "updateUser",
      "deleteUser",
      "getUsers",
    ]),
    copyIdToClipboard() {
      this.$clipboard(this.generatedPassword);
      this.$message.success(
        "'" +
        this.generatedPassword +
        "' " +
        this.$t("common.copyclipboardsuccess")
      );
    },
    dateDate(date) {
      return dayjs(date).format(preferences().localization.dateFormat);
    },
    CreateUserfunc() {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          this.createFormLoading = true;
          this.createUser(Object.assign({}, this.createForm))
            .then(() => {
              this.createFormLoading = false;
              this.showCreateForm = false;
            })
            .finally(() => (this.createFormLoading = false));
        }
      });
    },
    resetPassword(scope) {
      scope.row.resetPasswordVisible = false;
      axios
        .post(`${process.env.VUE_APP_APIURL}/user/${scope.row._id}/password`, {
          password: this.generatedPassword,
        })
        .then((res) => {
          this.$message({
            message: `${res.data.message}`,
            type: "success",
          });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },

    generatePassword(scope) {
      setTimeout(() => {
        scope.row.resetPasswordVisible = true;
      }, 300);


      this.generatedPassword = generatePass.generate({
        length: this.customer.preferences.passwordPolicy.minCharacter,
        numbers: this.customer.preferences.passwordPolicy.requiresNumbers,
        symbols: this.customer.preferences.passwordPolicy.requiresSpecialCharacters,
        lowercase: true,
        uppercase: this.customer.preferences.passwordPolicy.requiresUpperCaseLetters,
        exclude: '`~@#$%^&*()–_=+{}|;:‘“,<>?/[]-"',
        strict: true,
      });
    },
    Delete(id) {
      this.$confirm(this.$t("admin.warningtext"), this.$t("admin.warning"), {
        confirmButtonText: this.$t("admin.warningConfirmText"),
        cancelButtonText: this.$t("admin.warningCancelText"),
        type: "warning",
      })
        .then(() => this.deleteUser(id))
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("admin.warningDeleteCancel"),
          });
        });
    },
    UpdateUser() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.formLoading = true;
          this.form._id = this.editId;
          this.updateUser(this.form)
            .then(() => {
              this.formLoading = false;
              this.showForm = false;
            })
            .finally(() => (this.formLoading = false));
        }
      });
    },
    create() {
      if (this.$refs["createForm"] !== undefined) {
        this.$refs["createForm"].resetFields();
      }
      this.showCreateForm = true;
    },
    Edit(id) {
      this.editId = id;
      const user = this.users.find((x) => x._id == id);
      if (user) {
        this.form.name = user.name;
        this.form.surname = user.surname;
        this.form.phone = user.phone;
        this.form.email = user.email;
        this.form.password = user.password;
        this.form.role = user.role;
      }
      this.showForm = true;
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.el-dialog {
  margin-top: 15vh !important;
  width: 40% !important;
}

p {
  margin-left: 30px;
}

.el-form-item__content label.country-selector__label {
  line-height: normal;
}

.el-form-item__content label.input-tel__label {
  line-height: normal;
}

.vue-phone-number-input .select-country-container {
  min-width: 100px !important;
  max-width: 100px !important;
}
</style>
<style scoped>
.fa-clipboard {
  border: 2px solid #dcdfe6;
  padding: 5px;
  border-radius: 5px;
}

.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}

.tabs {
  flex-basis: 80%;
  display: flex;
}

.component {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}

.component-container {
  margin: 0 10px 20px 10px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  min-width: 300px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  flex: 1 0 48%;
}
.validateerrors{
  display:flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.validateerrors li{
  margin-top:10px;
  width:100%

}

</style>

